var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleIcon = function SvgGoogleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "M17.64 9.704q-.002-.957-.164-1.84H9v3.48h4.844a4.14 4.14 0 0 1-1.796 2.717v2.258h2.908c1.702-1.566 2.684-3.874 2.684-6.615",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "evenodd",
    d: "M9 18.5c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A9 9 0 0 0 9 18.5",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    fillRule: "evenodd",
    d: "M3.964 11.21a5.4 5.4 0 0 1-.282-1.71c0-.593.102-1.17.282-1.71V5.458H.957A9 9 0 0 0 0 9.5c0 1.452.348 2.827.957 4.042z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    fillRule: "evenodd",
    d: "M9 4.08c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.462 1.391 11.426.5 9 .5A9 9 0 0 0 .957 5.458L3.964 7.79C4.672 5.663 6.656 4.08 9 4.08",
    clipRule: "evenodd"
  })));
};
export default SvgGoogleIcon;